import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { Store } from '@ngxs/store';
import { ShiftScoreName } from '@wilson/interfaces';
import { PreferenceSettingsState } from '@wilson/preferences/state';
import { ScoreMap } from '@wilson/shift/core';
import { ScoreDisplayComponent } from '../score-display/score-display.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'wilson-tooltip-pref-score-breakdown',
  templateUrl: './tooltip-pref-score-breakdown.component.html',
  styleUrls: ['./tooltip-pref-score-breakdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ScoreDisplayComponent, TranslateModule],
})
export class TooltipPrefScoreBreakdownComponent {
  private readonly store = inject(Store);

  @Input() prefScores!: ScoreMap;
  ShiftScoreName = ShiftScoreName;

  readonly isLongShiftPrefEnabled$ = this.store.select(
    PreferenceSettingsState.isLongShiftPrefEnabled,
  );
}
